module.exports = __webpack_public_path__ + "static/media/message-icon-white-small.edd43f68.svg";